import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Connects to data-controller="tv-refresh"
export default class extends Controller {
  static values = { interval: { type: Number, default: 5000 } };

  connect() {
    this.timer = setInterval(() => this._refresh(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  _refresh() {
    Turbo.visit(window.location.href, { action: "replace" });
  }
}
